import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./i18n/LanguageContext";
import Auth from "./pages/Auth";
import Translator from "./pages/Translator";
import Account from "./pages/Account";
import Subscribe from "./pages/Subscribe";
import ResetPassword from "./pages/ResetPassword";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminSubmissions from "./pages/AdminSubmissions";
import AdminSubmissionDetail from "./pages/AdminSubmissionDetail";
import AdminMembershipApplications from "./pages/AdminMembershipApplications";
import MemberRegister from "./pages/MemberRegister";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";
import ExtensionInstallationGuide from "./pages/ExtensionInstallationGuide";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <LanguageProvider>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Translator />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/auth/reset-password" element={<ResetPassword />} />
            <Route path="/account" element={<Account />} />
            <Route path="/subscribe" element={<Subscribe />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/member-register" element={<MemberRegister />} />
            <Route path="/admin" element={<ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>} />
            <Route path="/admin/submissions" element={<ProtectedAdminRoute><AdminSubmissions /></ProtectedAdminRoute>} />
            <Route path="/admin/submissions/:id" element={<ProtectedAdminRoute><AdminSubmissionDetail /></ProtectedAdminRoute>} />
            <Route path="/admin/membership-applications" element={<ProtectedAdminRoute><AdminMembershipApplications /></ProtectedAdminRoute>} />
            <Route path="/extension-installation-guide" element={<ExtensionInstallationGuide />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
